import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('companies', {
      company: 'currentCompany',
    }),
    _() {
      return _;
    },
    companyId() {
      return this.company.id;
    },
  },
  watch: {
    companyId() {
      this.loadData();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/companySectionMixin.js